var _path, _path2, _path3, _mask, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BBBDC9",
    d: "M2.5 6.5H18.5V7.5H2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDC9",
    d: "M13 1H15V5H13zM5 1H7V5H5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#BBBDC9",
    d: "M5.5 10.5H6.5V11.5H5.5zM5.5 13.5H6.5V14.5H5.5zM9.5 10.5H10.5V11.5H9.5zM9.5 13.5H10.5V14.5H9.5zM13.5 10.5H14.5V11.5H13.5z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "5n1p1fk25a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    x: 1,
    y: 2,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    x: 1,
    y: 2,
    stroke: "#BBBDC9",
    strokeWidth: 4,
    mask: "url(#5n1p1fk25a)",
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5daed887872249012a18877c0efab5fe.svg";
export { ForwardRef as ReactComponent };